import { render, staticRenderFns } from "./BtnPoints.vue?vue&type=template&id=3fbd986e"
import script from "./BtnPoints.vue?vue&type=script&lang=ts"
export * from "./BtnPoints.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports